import "./DaEmailRequestPaused.css";
import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const formatRemainingTime = (remainingSeconds) => {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const DaEmailRequestPaused = ({ retryAfterSeconds = 300, onRequestNewLink, isBusy = false }) => {
  const [remainingSeconds, setRemainingSeconds] = useState(retryAfterSeconds);
  const isPaused = remainingSeconds > 0;

  useEffect(() => {
    setRemainingSeconds(retryAfterSeconds);
  }, [retryAfterSeconds]);

  useEffect(() => {
    if (!isPaused) return undefined;

    const timer = window.setInterval(() => {
      setRemainingSeconds((currentSeconds) => Math.max(0, currentSeconds - 1));
    }, 1000);

    return () => window.clearInterval(timer);
  }, [isPaused]);

  return (
    <DaPageWrapper
      wrapperClass="da-email-paused-card da-page-wrapper"
      iconType="mail"
      title={<Translate tKey={T_KEYS.DA.EMAIL_REQUEST_PAUSED.TITLE} />}
      subtitle={<Translate tKey={T_KEYS.DA.EMAIL_REQUEST_PAUSED.DESCRIPTION} />}
    >
      <Typography variant="caption" color="text.secondary" className="da-email-paused-wait">
        <span>{translateStatic(T_KEYS.DA.EMAIL_REQUEST_PAUSED.WAIT)} </span>
        <strong className="da-email-paused-timer">{formatRemainingTime(remainingSeconds)}</strong>
      </Typography>
      <Button
        type="button"
        variant="outlined"
        className="da-email-paused-request"
        disabled={isPaused || isBusy}
        onClick={onRequestNewLink}
      >
        {translateStatic(T_KEYS.DA.EMAIL_REQUEST_PAUSED.REQUEST_NEW_LINK)}
      </Button>
    </DaPageWrapper>
  );
};

DaEmailRequestPaused.propTypes = {
  retryAfterSeconds: PropTypes.number,
  onRequestNewLink: PropTypes.func.isRequired,
  isBusy: PropTypes.bool,
};

export { DaEmailRequestPaused };
